/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';

// #endregion Local Imports

const pathname = '/stamps';

export const StampApi = {
  filter: async (option: any) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithEntity: async (option: any) => {
    let url = `${pathname}/entity`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  validateStampNumber: async (option: ValidateStampNumberQuery) => {
    let url = `${pathname}/validate-stamp-number`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  activateStamp: async (body: any) => {
    try {
      const response = await entityService.post(
        `${pathname}/activate-stamp`,
        body
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  duplicateStamp: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/duplicate`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: any = {}) => {
    let url = `${pathname}/${id}`;
    if (Object.keys(option).length > 0) {
      const query = serialize(option);
      url += query;
    }

    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  findLogs: async (id: string, query?: any) => {
    let url = `${pathname}/${id}/logs`;
    if (query) {
      url += serialize(query);
    }
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};


export interface ValidateStampNumberQuery {
  stampNumber: number;
  ownerID?: string;
}
